import React from 'react';
import bgImage from '../../assets/servicesImages/webdev/hero.png';
import WebDevSection3 from '../../Pages/WebDevSection3';
import WebDevsection4 from '../../Pages/WebDevsection4';

const WebDev = () => {
    return (
        <div className='flex flex-col gap-16'>

            {/* Hero Section */}
            <div className='h-[40vh] md:h-[50vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center'

                style={{ backgroundImage: `url(${bgImage})` }}
            >
                <div className="absolute inset-0 bg-[rgba(0,0,0,0.45)] z-0 backdrop-blur-sm" />
                <div className='z-10 px-6 md:px-16 lg:px-28 max-w-3xl'>
                    <h1 className='font-nunito text-4xl md:text-5xl font-bold leading-tight mb-6'>
                        Website Development
                    </h1>
                    <p className="text-lg md:text-xl font-medium leading-relaxed">
                        We are a top web design and development company delivering highly professional, responsive, and budget-friendly website development services.
                    </p>
                </div>
            </div>

            {/* Intro Section */}
            <div className='flex flex-col gap-10 px-6 md:px-16 lg:px-28'>
                <h2 className='text-center font-nunito text-2xl md:text-3xl font-semibold'>
                    Website Development
                </h2>
                <p className='font-nunito text-base md:text-lg leading-7 text-justify text-[#4A5568]'>
                    eSparse Matrix Solutions Pvt Ltd is a leading Web & Software development company in Pune providing top-tier services. We help convert complex business processes into seamless workflow-based applications. 
                    <br /><br />
                    Our experienced developers are skilled in technologies like C, C++, SQL, C#, MFC, WebSockets, and more. From portals, CMS, and e-commerce to CRM, ERP, and SaaS solutions—we offer dedicated development for your specific needs.
                </p>
            </div>

            {/* Feature Sections */}
            <WebDevSection3 />
            <WebDevsection4 />
        </div>
    );
};

export default WebDev;
